module.exports = new __parcel__URL__("JSM-board-illustration.953abb9a.png").toString();